import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'

// Three.js loader promise rejections (a 404/corrupt model or texture) bypass
// React error boundaries — degrade to "no 3D" instead of an unhandled crash.
window.addEventListener('unhandledrejection', (e) => {
  const reason = String((e && e.reason && (e.reason.message || e.reason)) || '')
  if (/THREE|GLTF|\.glb|\.hdr|WebGL/i.test(reason)) e.preventDefault()
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
